import React from 'react';
import './TicketDisplay.css';
import { generateTicketPNG } from '../utils/ticketExport';

function TicketDisplay({ ticket, onBack, isNewTicket = false, hideBackButton = false, showCloseButton = false, onClose, isAdminView = false }) {
  const formatDate = (dateString) => {
    // Pokud už je to ISO formát (obsahuje T), použij přímo
    // Jinak převeď SQLite formát "YYYY-MM-DD HH:MM:SS" na ISO 8601
    const isoString = dateString.includes('T')
      ? dateString
      : dateString.replace(/\s+/, 'T') + 'Z';

    const date = new Date(isoString);

    // Fallback pokud date není validní
    if (isNaN(date.getTime())) {
      console.error('Invalid date:', dateString, 'converted to:', isoString);
      return 'Neplatné datum';
    }

    return date.toLocaleString('cs-CZ', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Europe/Prague'
    });
  };

  const shareOnFacebook = async () => {
    // Trackovat FB sdílení pouze pokud není admin view
    if (!isAdminView) {
      try {
        const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001');
        await fetch(`${API_URL}/api/tickets/${ticket.id}/fb-share`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        });
      } catch (error) {
        console.error('Chyba při trackování FB sdílení:', error);
      }
    }

    const ticketUrl = `${window.location.origin}/ticket/${ticket.id}`;
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(ticketUrl)}`;
    window.open(facebookShareUrl, '_blank');
  };

  const getExpectedDate = () => {
    const isoString = ticket.created_at.includes('T')
      ? ticket.created_at
      : ticket.created_at.replace(/\s+/, 'T') + 'Z';
    const createdDate = new Date(isoString);

    if (isNaN(createdDate.getTime())) {
      return ticket.expected_year;
    }

    const day = createdDate.getDate();
    const month = createdDate.toLocaleString('cs-CZ', { month: 'long', timeZone: 'Europe/Prague' });

    return `${day}. ${month} ${ticket.expected_year}`;
  };

  return (
    <div className="ticket-display-container">
      <div className="ticket-wrapper">
        <div className="ticket">
          {showCloseButton && (
            <button className="ticket-close-button" onClick={onClose}>
              ✕
            </button>
          )}

          <div className="ticket-body">
            <div className="ticket-number-display">
              <span className="number-label">Pořadové číslo:</span>
              <span className="number-value">#{ticket.ticket_number}</span>
            </div>

            <div className="ticket-info-section">
              <h4>Co potřebuji od státu:</h4>
              <div className="ticket-request-text">
                {ticket.request}
              </div>
            </div>

            <div className="ticket-timing">
              <div className="timing-item">
                <span className="timing-label">Vydáno:</span>
                <span className="timing-value">{formatDate(ticket.created_at)}</span>
              </div>
              <div className="timing-item expected">
                <span className="timing-label">Očekávané vyřízení:</span>
                <span className="timing-value highlight">{ticket.expected_year}</span>
              </div>
              <div className="wait-time">
                <span className="wait-text">
                  <strong>Datum vyřízení požadavku po schválení nekvalitního zákona o státních zaměstnancích: {getExpectedDate()}</strong>
                </span>
              </div>
            </div>
          </div>

          <div className="ticket-footer">
            <a href="https://www.nechcemestatvefronte.eu" target="_blank" rel="noopener noreferrer" className="footer-link">www.nechcemestatvefronte.eu</a>
          </div>
        </div>

        <div className="ticket-actions">
          {!hideBackButton && (
            <button className="btn-back" onClick={onBack}>
              ← Zpět na hlavní tabuli
            </button>
          )}
          <button
            className="btn-facebook"
            onClick={shareOnFacebook}
          >
            Sdílet na Facebooku
          </button>
        </div>

        <div className="ticket-actions-secondary">
          <button
            className="btn-png-format"
            onClick={() => generateTicketPNG(ticket, '4:5', !isAdminView)}
          >
            Stáhnout PNG ve formátu: 4:5 (na výšku/feed)
          </button>
          <button
            className="btn-png-format"
            onClick={() => generateTicketPNG(ticket, '9:16', !isAdminView)}
          >
            Stáhnout PNG ve formátu: 9:16 (story/reel)
          </button>
        </div>

        {isNewTicket && (
          <div className="motivational-message">
            <h3>✅ Lístek byl úspěšně vydán!</h3>
            <p>
              Vaše žádost byla zaregistrována a zařazena do systému.
            </p>
            <p className="message-humor">
              Prosíme o trpělivost. Vyřídíme to {getExpectedDate()}! 🐌
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default TicketDisplay;
